import { httpRequest } from "../../http";
import { CatalogMetric } from "@models/catalog.model";

export class CommandListCatalogMetrics {
  // Every metric in a vertical, already flattened + ordered (entity type, attr_key) by the API.
  async run(verticalCode: string): Promise<CatalogMetric[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/${encodeURIComponent(verticalCode)}/metrics/`;
    return httpRequest<CatalogMetric[]>(url, { method: "GET" });
  }
}
